/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface GestionDroitsSearch
 */
export interface GestionDroitsSearch {
    /**
     * 
     * @type {number}
     * @memberof GestionDroitsSearch
     */
    idaccesLevel?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GestionDroitsSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof GestionDroitsSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof GestionDroitsSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GestionDroitsSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof GestionDroitsSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof GestionDroitsSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the GestionDroitsSearch interface.
 */
export function instanceOfGestionDroitsSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GestionDroitsSearchFromJSON(json: any): GestionDroitsSearch {
    return GestionDroitsSearchFromJSONTyped(json, false);
}

export function GestionDroitsSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): GestionDroitsSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idaccesLevel': !exists(json, 'idaccesLevel') ? undefined : json['idaccesLevel'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function GestionDroitsSearchToJSON(value?: GestionDroitsSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idaccesLevel': value.idaccesLevel,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

